import {
  GET_USER_XP,
  GET_XP_HISTORY,
  GET_XP_LEADERBOARD,
  AWARD_XP,
  RESET_USER_XP,
  XP_LOADING
} from '../actions/types';

const initialState = {
  userXP: null,
  xpHistory: [],
  leaderboard: [],
  loading: false,
  awardResult: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_USER_XP:
      return {
        ...state,
        userXP: action.payload,
        loading: false
      };
    
    case GET_XP_HISTORY:
      return {
        ...state,
        xpHistory: action.payload,
        loading: false
      };
    
    case GET_XP_LEADERBOARD:
      return {
        ...state,
        leaderboard: action.payload,
        loading: false
      };
    
    case AWARD_XP:
      return {
        ...state,
        awardResult: action.payload,
        loading: false
      };
    
    case RESET_USER_XP:
      return {
        ...state,
        userXP: null, // Clear current user XP
        xpHistory: [], // Clear history
        awardResult: action.payload, // Store reset result
        loading: false
      };
    
    case XP_LOADING:
      return {
        ...state,
        loading: true
      };
    
    default:
      return state;
  }
}